// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7cb2e70f","667":"4c0560dc"}[chunkId] + ".chunk.js";
};